import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SliceTypes } from 'utils';
import { redirectButtonInitial } from './InitialStates/redirectButtonInitial';
import { RootState } from './rootReducer';

export const redirectButtonSlice = createSlice({
    name: SliceTypes.REDIRECT_BUTTON,
    initialState: redirectButtonInitial,
    reducers: {
        updateSitId: (
            state,
            { payload: { sitIdValue } }: PayloadAction<{ sitIdValue: string }>,
        ) => {
            state.sitIdValue = sitIdValue;
        },
        updateRedirect: (
            state,
            { payload: { redirectFromValue } }: PayloadAction<{ redirectFromValue: string }>,
        ) => {
            state.redirectFromValue = redirectFromValue;
        },
        updateRedirectUrl: (
            state,
            { payload: { redirectUrlValue } }: PayloadAction<{ redirectUrlValue: string }>,
        ) => {
            state.redirectUrlValue = redirectUrlValue;
        },
    },
});

export const { updateSitId, updateRedirect, updateRedirectUrl } = redirectButtonSlice.actions;

export const buttonStateSlice = (state: RootState) => state.redirectButton;

export default redirectButtonSlice.reducer;
